export default __webpack_public_path__ + "static/PEPENEMSTEAK-1d645623c1e602b892be2ff1c68d580f.jpg";